/**
 * Variable-schema types for Regta templates.
 *
 * Each template version owns a typed schema describing the variables its
 * component accepts. The schema drives the contract editor's form: which
 * inputs to render, in what section, with what visibility rules.
 *
 * Variable VALUES live on the contract row; variable SCHEMA lives in
 * code (this package). Pinning a contract to a `template_version_id`
 * also pins the schema — bumping a template version is a code change,
 * never a silent DB migration.
 */
/**
 * Helpers to normalise the boolean-or-object shape at call sites. Keep
 * call sites from re-implementing this — it's the union surface that
 * tends to drift first.
 */
export function isImportedField(field) {
    return Boolean(field.scopes?.imported);
}
export function importedFrom(field) {
    const s = field.scopes?.imported;
    if (typeof s === 'object' && s && 'from' in s && s.from)
        return s.from;
    return null;
}
export function importedRequiredForReview(field) {
    const s = field.scopes?.imported;
    return (typeof s === 'object' && s !== null && s.requiredForReview === true);
}
/**
 * Effective copy class for a field (per ADR-0050). Folds the two
 * "recomputed, never copy the literal" cases into `'never'`:
 *   - `autofill` fields — re-derived from the copied party/property.
 *   - `derivedFromParent` fields — overlaid from the parent at render.
 * Otherwise returns the declared `scopes.copy`, defaulting to `'auto'`.
 * Backend (`copy_from`) and the copy modal both resolve copyability
 * through this so they can never disagree.
 */
export function effectiveCopyClass(field) {
    if (field.autofill || field.derivedFromParent)
        return 'never';
    return field.scopes?.copy ?? 'auto';
}
//# sourceMappingURL=types.js.map